module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_8003.dbf3520c.png";